import React from 'react'
import {Box, Card, CardActionArea, CardContent, Typography} from "@mui/material";
import useStyles from "../../../assets/styles/HomeStyles";
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button} from "@material-ui/core";

const RatingReportTypesView = ({actions}) => {
    const {navigateToDQProgramRating, navigateToCPCProgramRating} = actions;
    const classes = useStyles();
    // const cardData = [
    //     {
    //         image: 'DQ Alignment',
    //         description: 'DQ Alignment instantly maps your digital literacy interventions (learning programs, frameworks, or assessments) to the IEEE DQ Global Standards (IEEE 3527.1™).',
    //         points: ['Maps against over 100 internationally recognized frameworks and research sources',
    //             'Tagged with the interoperable DQ Codes for credibility and scalability',
    //             'Generates report showcasing alignment and enhancement opportunities'],
    //         action: navigateToDQProgramRating,
    //     },
    //     {
    //         image: 'CPC Stars Rating',
    //         description: 'Program rating for organizations to check their child cyber citizenship or online safety program against the Child Protection in Cyberspace (CPC)’s Cyber Citizenship Framework.',
    //         points: ['Connects your program to CPC Index',
    //             'Generates report showcasing alignment and enhancement opportunities',
    //             'Shares what cyber-risks your program can help reduce'],
    //         action: navigateToCPCProgramRating,
    //     },
    // ];
    const alignmentData = [
        {
            topic: 'Basic Cyber Security and Privacy Management',
            competencies: [
                'Building ICT Literacy',
                'Enhancing Personal Digital Footprints and Reputations',
                'Developing Personal Device Security and Digital Hygiene',
                'Managing Personal Cyber Threats',
                'Protecting Privacy as a Human Right',
            ],
            dqCodes: [
                'DQCO.07.01',
                'DQCO.06.01',
                'DQCO.04.01',
                'DQCO.04.02',
                'DQCO.08.01',
            ],
        },
        {
            topic: 'Digital Footprint Management',
            competencies: [
                'Engaging Screen Time with Self-Control',
                'Using Technology Purposefully with Time Management',
                'Managing Cyberbullying',
                'Managing Contact Risks',
                'Managing Content Risks',
            ],
            dqCodes: [
                'DQCO.02.01',
                'DQCO.02.02',
                'DQCO.03.01',
                'DQCO.03.03',
                'DQCO.03.04',
            ],
        },
        {
            topic: 'Cyber Civility',
            competencies: [
                'Building a Congruent Online Persona with Integrity',
                'Establishing Identity as a Global Digital Citizen',
                'Developing Emotional Awareness in Digital Interactions',
                'Demonstrating Empathy and Perspective-Taking in Digital Interactions',
                'Practicing Media Literacy and Critical Information Evaluation',
            ],
            dqCodes: [
                'DQCO.01.01',
                'DQCO.01.02',
                'DQCO.05.01',
                'DQCO.05.02',
                'DQCO.07.02',
            ],
        },
    ];

    return (
        <>
            <Box className={classes.pageContainer}>
                <Typography variant="h3" sx={{ textAlign: "center", marginBottom:{sm:2, xs:1}, marginTop:{xs:'55px', sm:'0px'} }} className={classes.title}>
                    Welcome to DQ Stars Alignment
                </Typography>
                <Typography variant="h7" sx={{ textAlign: "center", marginBottom:{sm:0, xs:1}, marginTop:{xs:'55px', sm:'0px'} }} className={classes.subtitle}>
                    Content Alignment for Children’s Digital Citizenship Education
                </Typography>

                <Typography paragraph sx={{padding: '10px 150px',fontWeight:'regular',fontSize:'20px',marginTop:'10px',marginLeft:'10px', height: '100px', textAlign: 'left',}}>
                    The DQ Stars Alignment is a powerful evaluation tool designed to assess digital citizenship education programs for children and youth based on the {' '}
                    <span style={{fontWeight:'bold'}}>Digital Citizenship for Children (DCC) Framework.</span>
                </Typography>

                <Box
                    display="flex"
                    flexDirection={{ xs: 'column', md: 'row' }}
                    justifyContent="space-between"
                    sx={{ padding: '0 50px', marginTop: '0px', width:'90%', }}
                >
                    {/* LEFT BOX */}
                    <Box sx={{
                            display:'flex',
                            flexDirection:'column',
                            alignItems:'center',
                            justifyContent:'center',
                            backgroundColor: '#fff',
                            borderRadius: '20px',
                            padding: '20px',
                            flex: 0.6,
                            marginRight: { md: '30px', xs: '0px' },
                            marginBottom: { xs: '20px', md: '0px' },
                        }}
                    >
                        <Typography paragraph sx={{ color: '#EE6628', fontWeight: 'bold', fontSize: '16px' }}>
                            Digital citizenship encompasses a set of core competencies essential for individuals to navigate cyberspace safely, responsibly, and ethically.
                        </Typography>
                        <Typography paragraph sx={{fontWeight: 'light', fontSize: '15px' }}>
                            <span style={{fontWeight:'bold'}}>The Digital Citizenship for Children (DCC) Framework </span>focuses specifically on the key competencies children need to effectively manage and mitigate various cyber-risks, while also supporting their cognitive, psychological, social, emotional development, and overall mental health.
                        </Typography>
                        <Typography paragraph sx={{fontWeight: 'light', fontSize: '15px' }}>
                            The DCC framework is structured around three core topics - Basic Cyber Security & Privacy Management, Cyber Safety Management, and Cyber Civility – and further broken down into <span style={{fontWeight:'bold'}}>15 specific competencies.</span> These competencies are aligned with the globally recognized <span style={{fontWeight:'bold'}}>IEEE DQ Global Standards (IEEE 3527.1™)</span> for digital literacy, skills, and readiness.                        </Typography>
                    </Box>

                    {/* RIGHT TABLE */}
                    <Box sx={{
                        flex: 1,
                        marginRight: { md: '30px', xs: '0px' },
                        marginBottom: { xs: '20px', md: '0px' },
                    }}
                    >
                    <TableContainer component={Paper} className={classes.table}>
                        <Table>
                            <TableHead className={classes.tableHeader}>
                                <TableRow>
                                    <TableCell className={classes.tableHeaderCell}>Topics</TableCell>
                                    <TableCell className={classes.tableHeaderCell}>
                                        Essential Digital Citizenship Competencies for Children
                                    </TableCell>
                                    <TableCell className={classes.tableHeaderCell}>DQ Codes</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {alignmentData.map((row, rowIndex) =>
                                    row.competencies.map((comp, i) => (
                                        <TableRow
                                            key={`${rowIndex}-${i}`}
                                            sx={{ height: '30px' }}
                                        >
                                            {i === 0 && (
                                                <TableCell rowSpan={5}  style={{ width: '17%' }} className={`${classes.tableCell} ${classes.topicCell}`}>
                                                    {row.topic}
                                                </TableCell>
                                            )}
                                            <TableCell className={classes.tableCell}>
                                                {comp}
                                            </TableCell>
                                            <TableCell className={classes.tableCell}>
                                                {row.dqCodes[i]}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '40px', marginBottom: '20px' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={navigateToCPCProgramRating}
                    >
                        Next
                    </Button>
                </Box>


            </Box>


            {/*<Box className={classes.pageContainer}>*/}
            {/*    <Typography variant="h3" sx={{*/}
            {/*        textAlign: "center",*/}
            {/*        marginBottom: {sm: 5, xs: 1},*/}
            {/*        marginTop: {xs: '55px', sm: '40px'}*/}
            {/*    }} className={classes.title}>*/}
            {/*        Select a Test*/}
            {/*    </Typography>*/}

            {/*    <Box className={classes.cardsContainer} sx={{flexDirection: {xs: "column", sm: "row"},}}>*/}
            {/*        {cardData.map((card, index) => (*/}
            {/*            <Card key={index} className={classes.card} onClick={card.action}>*/}
            {/*                    <CardContent className={classes.cardContent}>*/}
            {/*                        /!*<img src={card.image} className={classes.cardImage}/>*!/*/}
            {/*                        <Typography variant="h6" className={classes.cardText}>*/}
            {/*                            {card.image}*/}
            {/*                        </Typography>*/}
            {/*                        <Typography variant="body1" paragraph*/}
            {/*                                    style={{*/}
            {/*                                        padding: '10px',*/}
            {/*                                        marginTop: '20px',*/}
            {/*                                        marginLeft: '10px',*/}
            {/*                                        height: '100px',*/}
            {/*                                        textAlign: 'left',*/}
            {/*                                        color: '#5A5A5A',*/}
            {/*                                        marginBottom:'50px',*/}
            {/*                                    }}>*/}
            {/*                            {card.description}*/}
            {/*                        </Typography>*/}
            {/*                        <ul>*/}
            {/*                            {card.points.map((point, idx) => (*/}
            {/*                                <li key={idx} className={classes.listItemText}>*/}
            {/*                                    {point}*/}
            {/*                                </li>*/}
            {/*                            ))}*/}
            {/*                        </ul>*/}
            {/*                    </CardContent>*/}
            {/*            </Card>*/}
            {/*        ))}*/}
            {/*    </Box>*/}
            {/*</Box>*/}
        </>
    )
}

export default RatingReportTypesView;